export type OpeningPreference = "full" | "fast" | "off";

export const OPENING_STORAGE_KEY = "kikik.mahjong.opening-animation";

export function readOpeningPreference(storage?: Storage): OpeningPreference {
  try {
    const value = (storage ?? globalThis.localStorage)?.getItem(OPENING_STORAGE_KEY);
    return value === "fast" || value === "off" || value === "full" ? value : "full";
  } catch {
    return "full";
  }
}

export function persistOpeningPreference(value: OpeningPreference): void {
  try {
    globalThis.localStorage?.setItem(OPENING_STORAGE_KEY, value);
  } catch {
    // Presentation preference only: restricted storage must not block a game.
  }
}
